// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrnotificationspg-inline-1 {
  margin-bottom: 14px;
}

.hrnotificationspg-inline-2 {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
}

.hrnotificationspg-inline-3 {
  margin-bottom: 12px;
}

.hrnotificationspg-inline-4 {
  padding: 0;
}

.hrnotificationspg-inline-5 {
  text-align: center;
  padding: 24px;
}

.hrnotificationspg-inline-6 {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
}

.hrnotificationspg-inline-7 {
  font-weight: 600;
  font-size: 13px;
}

.hrnotificationspg-inline-8 {
  font-size: 12px;
  color: #64748b;
  margin-top: 3px;
}

.hrnotificationspg-inline-9 {
  font-size: 15px;
  font-weight: 700;
}

.hrnotificationspg-inline-10 {
  margin-top: 8px;
  color: #475569;
}

.hrnotificationspg-inline-11 {
  margin-top: 12px;
}

.hrnotificationspg-dyn-1 {
  cursor: pointer;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  background: var(--hrnotificationspg-1-background);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/HrNotificationsPg.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,iDAAiD;AACnD","sourcesContent":[".hrnotificationspg-inline-1 {\n  margin-bottom: 14px;\n}\n\n.hrnotificationspg-inline-2 {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n}\n\n.hrnotificationspg-inline-3 {\n  margin-bottom: 12px;\n}\n\n.hrnotificationspg-inline-4 {\n  padding: 0;\n}\n\n.hrnotificationspg-inline-5 {\n  text-align: center;\n  padding: 24px;\n}\n\n.hrnotificationspg-inline-6 {\n  text-align: center;\n  padding: 24px;\n  color: #94a3b8;\n}\n\n.hrnotificationspg-inline-7 {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.hrnotificationspg-inline-8 {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 3px;\n}\n\n.hrnotificationspg-inline-9 {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.hrnotificationspg-inline-10 {\n  margin-top: 8px;\n  color: #475569;\n}\n\n.hrnotificationspg-inline-11 {\n  margin-top: 12px;\n}\n\n.hrnotificationspg-dyn-1 {\n  cursor: pointer;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  background: var(--hrnotificationspg-1-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
